export default class Validity {
  public static isValidEmail(email: string): boolean {
    return /^[a-zA-Z0-9!#$%&'*+-/=?^_`{|}~.]+@[^@]+\.[a-zA-Z0-9]{2,}/.test(email);
  }
}
